import { countBy } from 'lodash';
import { PostDatingSkipReason } from '@dealstack/shared/lib/backendClient';
import type { BulkApplyDateSkippedItemRes } from '@dealstack/shared/lib/backendClient';
import type { SkippedReasonBucket } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/BulkApplyDateModal.types';

/** One row per reason, in enum order — a greedy selection can skip tens of thousands of documents. */
export const bucketSkippedByReason = (
	skipped: BulkApplyDateSkippedItemRes[]
): SkippedReasonBucket[] => {
	const counts = countBy(skipped, (item) => item.reason);

	return Object.values(PostDatingSkipReason)
		.filter((reason) => counts[reason] > 0)
		.map((reason) => ({ reason, count: counts[reason] }));
};
